/*
 * @Author: wzc
 * @Date: 2021-10-25 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 定制化组件:不同项目引入不同组件
 * @LastEditTime: 2021-10-25 19:11:02
 */

import customizePro from './getCustomizePro'

const footerComp = () =>
  import(
    /* webpackChunkName: "footerComp" */ `@components/customizeComp/${customizePro}/footer.vue`
  )

export default {
  components: {
    footerComp,
  },
  data() {
    return {
      customizePro,
      footerCustomDom: footerComp,
    }
  },
}
